export const CHANNEL = "dash-deck-sync";

export const openPresenter = () =>
  window.open(`${window.location.pathname}?presenter=1`, "dash-presenter", "width=1100,height=760");
